import { h, JSX } from "preact";

import classname from "../../../foundation/utils/classname";
import { highlightMatchedParts } from "../../../foundation/utils/platform_ts";

import styles from "./HighlightText.module.css";

type NativeDivProps = JSX.HTMLAttributes<HTMLDivElement>;

interface HighlightTextProps {
    text: string;
    filterValue?: string;
    caseInsensitive?: boolean;
    enableWordSearch?: boolean;
    excludeZeroScore?: boolean;
    completeMatch?: boolean;
    highlightClass?: string;
}

type Props = HighlightTextProps & NativeDivProps;

function HighlightText({
    class: cssClass,
    text,
    filterValue,
    caseInsensitive = true,
    enableWordSearch = false,
    excludeZeroScore = false,
    completeMatch = false,
    highlightClass,
    ...nativeProps
}: Props) {
    const defaultContent = <div class={classname(styles.highlightText, cssClass)}>{text}</div>;

    if (!filterValue) {
        return defaultContent;
    }

    if (completeMatch) {
        const regexFlags = caseInsensitive ? "ig" : "g";
        const highlightRegex = new RegExp(`\\s*\\b${text}\\b\\s*`, regexFlags);

        if (!highlightRegex.test(filterValue)) {
            return defaultContent;
        }

        return (
            <div class={classname(styles.highlightText, cssClass)}>
                <span class={classname(styles.highlight, highlightClass)}>{text}</span>
            </div>
        );
    }

    const highlightedContent = highlightMatchedParts(text, filterValue, {
        caseInsensitive,
        enableWordSearch,
        excludeZeroScore,
        highlightClass: classname(styles.highlight, highlightClass)
    });

    return (
        <div
            {...nativeProps}
            class={classname(styles.highlightText, cssClass)}
            dangerouslySetInnerHTML={{ __html: highlightedContent }}/>
    );
}

export default HighlightText;
export { HighlightTextProps };
